import cv from './cv'
import user from './user'
import templates from './templates'
import global from './global'
import inbox from './inbox'
import intention from './intention'
import online from './online-cv'
import jobs from './jobs'
import staticApi from './static-api'
import HrApi from './hr'
import auth from './auth'
import nps from './nps'
import bbs from './bbs'
import blog from './blog'
import community from './community'
import hackathon from './hackathon'
import cvComment from './cvComment'
import io from './io'
import campusOffers from './campus-offers'
import ai from './ai'
import cvShare from './cvShare'
import thirdParty from './third-party'
import transferStation from './transfer-station'
import recommend from './recommend'
import space from './space'
import live from './live'
import im from './im'
import portrait from '@/api/api-list/portrait'
import campaign from './campaign'

export default {
  cv,
  user,
  templates,
  global,
  inbox,
  intention,
  staticApi,
  auth,
  online,
  HrApi,
  jobs,
  nps,
  bbs,
  blog,
  community,
  hackathon,
  cvComment,
  io,
  campusOffers,
  ai,
  cvShare,
  thirdParty,
  transferStation,
  recommend,
  space,
  live,
  im,
  portrait,
  campaign,
}
